import React from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import team5 from "../../assets/img/team/dr_lokesh1.png";
import team6 from "../../assets/img/team/dr_mukesh.jpg";
import MainHeader from "../common/MainHeader";
import MainFooter from "../common/MainFooter";
const data = {
  mukeshjain: {
    image: team6,
    name: "Dr. Mukesh Jain",
    degree: "MBSS, MD",
    about:
      `<p>Dr. Mukesh Jain is an experienced and professionally qualified Public Health Specialist, Consultant physician and diabetologist with a demonstrated track record of over 12+ years in patient care and over 6+ years in Health System Strengthening, Hospital administration, Pandemic response, Clinical Epidemiology & Research, Disease Surveillance, Outbreak/Disasters management, Program Administration and management and Inter-Sectoral coordination with World Health Organisation, Union Ministry of Health & Family Welfare, international NGOs and other multinational companies.</p>
      <p>Fellowship in Diabetes mellitus</p>
      <p>M.D. Community health administration from National Institute of Health & Family Welfare, University of Delhi (2017-20) </p>
      <p>M.B.B.S. – Stanley Medical College, The T.N. Dr M.G.R. Medical University, Chennai </p>
      `,
  },
  lokeshGarg: {
    image: team5,
    name: "Dr. Lokesh Kumar Garg",
    degree: "MBSS, DTCD, IDCCM,PGDS,MD (AM)",
    about:
      `<p>With 14+ years of experience, Dr. Lokesh Garg is a skilled Pulmonologist, Allergist/Immunologist, and General Physician practicing in Faridabad City, Faridabad. He offers his services at Arsh Hospital in Faridabad City and Park Hospital, Faridabad located in N.T.P.C. Sector-10, Faridabad.
      </p>
      <p>Dr. Garg earned his MBBS degree from Stanley Medical College And Hospital, Chennai in 2003. He also holds the degree of PGDS ( post graduate diploma in Sonography), Diploma in Tuberculosis and Chest Diseases (DTCD) from V.P Chest Institute, Delhi obtained in 2009, and IDCC (ISCCM) from Fortis Escorts Hospital, Faridabad in 2011.</p>
      <p>As a member of multiple medical associations such as Indian College of Chest Physician, Indian Society of Critical Care Medicine (ISCCM), Critical care department at Fortis Escorts hospital Faridabad, Respiratory medicine department at Asian Hospital Faridabad, Respiratory medicine department at Park Hospital Faridabad, American College of Allergy, Asthma and applied Immunology, South Asia Association of Allergy, Asthma and Clinical Immunology, and Haryana Chest Physician Society, Dr. Garg stays updated with the latest advancements in his fields.      </p>
      <ul>
      <li>PGDS ( post graduate diploma in Sonography), DTCD from V.P Chest Institute, Delhi in 2009</li>
      <li>Member of multiple medical associations</li>
      <li>14+ years of experience</li>
      </ul>
      `,
  },
};

function AboutDoctor() {
  const { isLogin } = useSelector((state) => state.login);

  const params = useParams();
  const name = params.name;

  return (
    <>
      <head>
        <title>Fever99</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </head>
      <MainHeader />
      <main id="main">
        {/* <div className="breadcrumbs">
          <nav>
            <div className="container">
              <ol>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>People</li>
              </ol>
            </div>
          </nav>
        </div>
        <section id="about" className="about">
          <div className="container" >
            <div style={{ display: "flex", justifyContent: "start", backgroundColor: '#f1f1f1', borderTopLeftRadius: '100px', borderBottomLeftRadius: '100px' }}>
              <img
                src={data[name].image}
                style={{ height: "200px", borderRadius: "50%" }}
                className="img-fluid"
                alt=""
              />

              <div style={{ display: 'flex', flexDirection: "column", justifyContent: 'center', marginLeft: '30px' }} >
                <h3 style={{ width: "100%" }}>{data[name].name}</h3>
                <h4 style={{ width: "100%" }}>{data[name].degree}</h4>
              </div>
            </div>
            <div dangerouslySetInnerHTML={{ __html: data[name].about }} style={{ marginTop: '20px' }}>
            </div>
          </div>
        </section> */}

        <section className="page-title bg-1">
          <div className="breadcrumbs">
            <div className="wrapper" style={{ backgroundImage: `url("https://wordpress.themeholy.com/mediax/wp-content/uploads/2023/12/breadcumb-bg.jpg")` }}>
              <div className="page-header d-flex align-items-center">
                <div className="container position-relative">
                  <div className="row d-flex justify-content-center">
                    <div className="col-lg-6 text-center">
                      <h3 style={{ width: "100%" }}>{data[name].name}</h3>
                      <nav>
                        <div className="container">
                          <ol>
                            <li>
                              <Link to="/">Home</Link>
                            </li>
                            <li>People</li>
                          </ol>
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section doctor-single py-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="doctor-img-block">
                  <img
                    src={data[name].image}
                    className="img-fluid"
                    style={{ borderRadius: "10px" }}
                    alt=""
                  />
                  <div className="info-block mt-4">
                    {/* <h3 style={{ width: "100%" }}></h3> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-8 col-md-6">
                <div className="doctor-details mt-4 mt-lg-0">
                  <h3 className="text-md">About <span>{data[name].name}</span></h3>
                  <p style={{ width: "100%" }}>{data[name].degree}</p>
                  <img src="/image/index/header-bottom.svg" alt="" style={{ width: "200px" }} />
                  <div dangerouslySetInnerHTML={{ __html: data[name].about }} style={{ marginTop: '5px', textAlign: "justify" }}>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <MainFooter />
      </main>
    </>
  );
}

export default AboutDoctor;
